module.exports = __webpack_public_path__ + "img/close.00e2da19.svg";